import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { SmileySimpleSmile2 as Svg } from './svgs/SmileySimpleSmile2.svg';

export const SmileySimpleSmile2 = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
